import React, { useState } from "react";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";

import useAddOfficeType from "./hooks/useAddOfficeType";
import useOfficeType from "./hooks/useOfficeType";
import { useRecoilState } from "recoil";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import { addStateOfficeType, setFilterTextOfficeType } from "./atoms/atoms";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import { useQueryClient } from "react-query";

const OfficeTypeForm = () => {
  //Hooks
  const { mutateAsync: AddOfficeType } = useAddOfficeType();
  const { data } = useOfficeType();
  //Recoils Call
  const [actionAddState, setActionAddState] =
    useRecoilState(addStateOfficeType);
  const [filterText, setFilterText] = useRecoilState(setFilterTextOfficeType);
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasOfficeType, setHasOfficeType] = useState(false);
  const userAccount = useRecoilState(accountAtom);
  const queryClient = useQueryClient();

  const defaulValues = {
    OfficeTypeId: 0,
    OfficeTypeName: "",
    glnumber: "",
  };
  const [emptypeNewData, setNewData] = useState([defaulValues]);
  const [OfficeTypeExist, setOfficeTypeExist] = useState(false);

  const handleAddOfficeType = (SourceType, fieldName, inputvalue) => {
    setChanged(true);
    setOfficeTypeExist(false);
    inputvalue = inputvalue.trim();
    if (SourceType === "addOfficeType") {
      if (fieldName === "OfficeTypeName") {
        const result = data.filter(
          (item) =>
            item.officeTypeName.toUpperCase() === inputvalue.toUpperCase()
        )[0];
        emptypeNewData.map((x) => (x.OfficeTypeName = inputvalue));
      }
    }
    inputvalue === "" ? setHasOfficeType(false) : setHasOfficeType(true);
  };

  //save changes
  const handleSave = (emptypeNewData) => {
    setOpenModal(false);
    if (actionAddState) {
      AddOfficeType(emptypeNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModal(false);
          } else {
            setActionAddState(false);
            setNewData([defaulValues]);
            queryClient.invalidateQueries(["GetOfficeTypes"]);
            toast.fire("Success", "Office Type Added Successfully", "success");
            setOpenModal(false);
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Add Office Type", "error");
          queryClient.invalidateQueries(["GetOfficeTypes"]);
        },
      });
    }
  };
  // end of saving changes

  const matcolumns = [
    {
      title: "Office Type Name",
      field: "OfficeTypeName",
      render: (rowData) => {
        return (
          <div className="grid-cols-3 grid ">
            <div className="">
              <TextInput
                defaultValue={rowData.officeTypeName}
                onChange={(e) =>
                  handleAddOfficeType(
                    "addOfficeType",
                    "OfficeTypeName",
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="animate-fade-in-down">
      <div className="w-full ">
        <ConfirmBoxModal
          ModalTitle="Add Office Type"
          qConfirmation=" Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(emptypeNewData);
          }}
        />
        <div className="p-3  space-y-1 border-l-2  border-primary box-shadow">
          <div className="flex items-center justify-between">
            <div className="text-base text-primary font-bold">
              Add New Office Type
            </div>
            <div className="flex items-center space-x-2 pt-2 pb-2">
              <SaveButton
                className={`flex items-left shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${!hasOfficeType ? "opacity-50" : "opactiy-100"}`}
                disabled={!hasOfficeType}
                onClick={() => setOpenModal(true)}
              />
              <CancelButton
                className="flex items-left text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1  "
                onClick={() => {
                  setActionAddState(!actionAddState);
                  setFilterText("");
                }}
              />
            </div>
          </div>

          <div className="mt-2 h-0.5 w-full border-b-2 border-secondary mb-5  "></div>

          <div className="py-1"></div>

          <div className="space-y-5 space-x-2 space-y-20 w-full   ">
            <MaterialExTable
              columns={matcolumns}
              data={emptypeNewData}
              paging={false}
            />
          </div>
        </div>
        <div className="hidden sm:block" aria-hidden="true">
          <div className="pb-1.5">
            <div />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfficeTypeForm;
